import React from 'react';
import { Pill, PillSizes, Button, ButtonVariants, ButtonColors, Text } from '@clockout-dev/design-elements';
import { LEDGER_CLEAR_FILTERS_LABEL } from '../../common/ledgerTable/ledgerTable.constants';
import styles from './styles/reports-active-filters.module.scss';

/**
 * The active filters, visible as chips, with one "Clear filters" action.
 * Renders nothing when no filter is set. Labels arrive ready-made from the
 * controller (`getActiveTransactionFilterChips`), so this stays presentational.
 * A `<section>` rather than a div so the `aria-label` is actually announced —
 * a label on a generic element is not.
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string}>} props.chips
 * @param {() => void} props.onClear
 */
function ReportsActiveFilters({ chips, onClear }) {
    if (!chips?.length) return null;

    return (
        <section className={styles.container} aria-label="Active filters">
            <div className={styles.chips}>
                {chips.map((chip) => (
                    <Pill
                        key={chip.key}
                        size={PillSizes.SMALL}
                        text={chip.label}
                        textSize="xs"
                        classNames={{ root: styles.chip }}
                    />
                ))}
            </div>
            <Button
                variant={ButtonVariants.DEFAULT}
                color={ButtonColors.SECONDARY}
                onClick={() => onClear?.()}
                className={styles.clear}
            >
                <Text size="xs" fontWeight="semibold">
                    {LEDGER_CLEAR_FILTERS_LABEL}
                </Text>
            </Button>
        </section>
    );
}

export default ReportsActiveFilters;
